<template>
  <v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
    <v-card v-if="value">
      <v-card-title>{{ $t('firmware.pin.title') }}</v-card-title>
      <v-card-subtitle>{{ $t('firmware.pin.explained') }}</v-card-subtitle>
      <v-card-text>
        <v-select
            v-model="versionId"
            :items="versions"
            item-value="id"
            :item-text="version => version.version + (version.status !== 'validated' ? ' (' + $t('firmware.firmware-statuses.' + version.status) + ')' : '')"
            :label="$t('firmware.pin.version')"
            outlined
            dense
        />
        <v-textarea v-model="reason" :label="$t('firmware.pin.reason')" :hint="$t('firmware.pin.reason-hint')" persistent-hint rows="2" auto-grow outlined dense />
        <v-text-field v-model="reviewAt" type="date" :label="$t('firmware.pin.review-at')" :hint="$t('firmware.pin.review-hint')" persistent-hint outlined dense class="mt-3" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small text @click="$emit('input', false)">{{ $t('cancel') }}</v-btn>
        <v-btn small color="primary" :disabled="!versionId || !reason.trim()" :loading="saving" @click="save">{{ $t('firmware.pin.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FirmwareRepository from "@repository/FirmwareRepository";

/**
 * Figer une borne sur un firmware (ou changer le firmware, le motif, la date de revue) : elle ne suit plus la dernière
 * version validée et sort des mises à jour groupées. Par défaut, le firmware qu'elle a déjà.
 */
export default {
  props: {
    value: {type: Boolean, default: false},
    chargingPointId: {type: String, required: true},
    currentVersion: {type: String, default: null},
    versions: {type: Array, default: () => []},
    pin: {type: Object, default: null},
  },

  data() {
    return {
      versionId: null,
      reason: '',
      reviewAt: '',
      saving: false,
    }
  },

  watch: {
    value(open) {
      if (open) {
        const current = this.versions.find(version => version.version === this.currentVersion)
        this.versionId = this.pin?.versionId || current?.id || null
        this.reason = this.pin?.reason || ''
        this.reviewAt = this.pin?.reviewAt || ''
      }
    },
  },

  methods: {
    save() {
      this.saving = true
      FirmwareRepository.pin(this.chargingPointId, this.versionId, this.reason.trim(), this.reviewAt || null).then(() => {
        this.notifySuccess('firmware.pin.saved')
        this.$emit('input', false)
        this.$emit('saved')
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>
